var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-simple-text"},[_c('el-skeleton',{attrs:{"animated":_vm.animated,"count":_vm.count}},[_c('template',{slot:"template"},[_c('div',[_c('el-skeleton-item',{attrs:{"variant":"p"}})],1)])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }